import { render, staticRenderFns } from "./MyTravelsPage.vue?vue&type=template&id=7e54d16e&scoped=true&"
import script from "./MyTravelsPage.vue?vue&type=script&lang=js&"
export * from "./MyTravelsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54d16e",
  null
  
)

export default component.exports